// extracted by mini-css-extract-plugin
module.exports = {"base":"_3FpseBmCJEZmaOrq_JdVzy","header":"_3HEbNkiA-RMJs7pjKiUM1M","avatarWrapper":"_30FklRD0OlRajyuvwey0y5"};